import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setPageTitle } from 'src/features/masthead/mastheadSlice';

export const usePageTitle = (title: string): void => {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(setPageTitle(title));
	}, [dispatch, title]);
};
